import dayjs from 'dayjs';

const tzOffset = new Date().getTimezoneOffset();
export default (timestamp: string, localeTag = 'en'): string => {
  return dayjs(timestamp, {utc: true})
    .locale(localeTag)
    .utcOffset(-tzOffset)
    .format('D MMMM YYYY, HH:mm');
};
